module.exports = "/packs/sns-facebook-ebfcc167b9395d89e287db82094dbce6.png";